<template>
  <div id="enterprise">
    <div class="enterprise-top">
      <div class="enter-title">
        <div class="t-left">便企查询</div>
        <div class="t-right" @click=";(showArea = true), buriedPoint()">
          筛选<i></i>
        </div>
      </div>
      <van-search
        v-model="departmentName"
        value=""
        shape="round"
        placeholder="请输入政府部门名称"
        @input="departmentSearch"
      />
    </div>
    <div
      class="r-list"
      v-if="
        (departmentList && departmentList.length > 0) ||
          (government && government.length > 0)
      "
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(item, index) in departmentList"
          :title="item.name"
          :key="index"
          :name="index + ''"
        >
          <div class="office">
            <div
              class="office-list"
              v-for="(items, level) in item.departList"
              :key="level"
              @click="detailse(items.id)"
            >
              <div class="list-title">
                <i></i>
                {{ items.name }}
              </div>
              <div class="list-address">
                <i></i>
                {{ items.address }}
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
      <div class="office government">
        <div
          class="office-list"
          v-for="(items, index) in government"
          :title="items.name"
          :key="index"
          @click="detailse(items.id)"
        >
          <div>
            <div class="list-title">
              <i></i>
              {{ items.name }}
            </div>
            <div class="list-address">
              <i></i>
              {{ items.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-empty description="未找到匹配的结果" v-else />
    <van-popup v-model="showArea" position="bottom">
      <van-picker
        @confirm="onConfirmHj"
        @change="onChangeHjData"
        show-toolbar
        title="选择机关类型"
        :columns="columns"
        :columns-field-names="customFieldName"
        @cancel="showArea = false"
      />
      <!--  -->
    </van-popup>
  </div>
</template>

<script>
// import { enterpriseAPI, screen, screenList } from '@api/lishui'
import { listTop, listAllDepart } from '@api/lishui'
import { getToken } from '@utils'
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  name: 'Enterprise',
  data() {
    return {
      jobsShow: true,
      columns: [],
      showArea: false,
      departmentList: [],
      government: [],
      departmentName: '',
      activeName: 1,
      countyName: '',
      selectName: '',
      customFieldName: {
        values: 'name'
      },
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.name) {
      this.countyName = this.$route.query.name
    }
    if (getToken()) {
      this.department()
      this.officeList()
    }
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 筛选列表
    officeList() {
      listTop({ areaName: this.countyName }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          res.data.map(value => {
            this.columns.unshift({
              id: value.id,
              text: value.name
            })
          })
          this.columns.unshift({ text: '全部', id: '' })
        }
      })
    },
    // 科室列表
    department() {
      this.departmentList = []
      this.government = []
      listAllDepart({
        name: this.departmentName,
        areaName: this.countyName,
        departId: this.selectName
        // type: this.selectName === '全部' ? '' : this.selectName
      }).then(response => {
        let res = response.data
        if (res.code == '0000') {
          res.data.map(f => {
            if (f.depType === 2) {
              this.government.push(f)
            } else {
              this.departmentList.push(f)
            }
          })
        }
      })
    },
    departmentSearch() {
      this.department()
    },
    // 详情
    detailse(e) {
      this.buriedPoint()
      this.$router.push({ name: 'details', query: { id: e } })
    },
    // 确认
    onConfirmHj(value) {
      this.showArea = false
      this.selectName = value.id
      this.department()
      // screen({ type: value === '全部' ? '' : value }).then(response => {
      //   let res = response.data
      //   if (res.code == '0000') {
      //     this.departmentList = []

      //     this.departmentList = res.data
      //   }
      // })
    },
    // 改变地区
    onChangeHjData(picker, values, index) {
      // console.log(picker, values, index);
    }
  }
}
</script>

<style lang="scss" scoped>
#enterprise {
  .enterprise-top {
    padding: 18px 20px 23px;
    color: #fff;
    background: url(../../../assets/enterprise/background.png) no-repeat;
    background-size: 100%;
    .enter-title {
      overflow: hidden;
      .t-left {
        float: left;
        font-size: 18px;
        color: rgba(255, 255, 255, 100);
      }
      .t-right {
        float: right;
        font-size: 12px;
        line-height: 24px;
        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          vertical-align: sub;
          background: url(../../../assets/enterprise/screen.png) no-repeat;
          background-size: 100%;
          margin-left: 8px;
        }
      }
    }
    .van-search {
      padding: 0;
      border-radius: 12px;
      margin-top: 8px;
    }
  }
  /deep/.van-collapse-item__content {
    padding: 0 16px;
  }
  /deep/.van-cell {
    font-size: 16px;
  }
  .office {
    background-color: #fff;

    .office-list {
      border-bottom: 1px solid #e6e6e6;
      padding: 16px 0;
      .list-title {
        font-size: 15px;
        color: #000000;
        i {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-top: 2px;
          background: url(../../../assets/enterprise/office.png) no-repeat;
          background-size: 100%;
          vertical-align: top;
          margin-right: 6px;
        }
      }
      .list-address {
        font-size: 12px;
        margin-top: 10px;
        color: rgba(0, 0, 0, 0.55);
        i {
          display: inline-block;
          width: 10px;
          height: 12px;
          margin-top: 2px;
          background: url(../../../assets/enterprise/address.png) no-repeat;
          background-size: 100%;
          vertical-align: top;
          margin-right: 6px;
        }
      }
    }
    .office-list:last-child {
      border-bottom: none;
    }
  }
  .government {
    padding: 0 10px;
  }
}
</style>
